<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1325px"
    height="1330.8px" viewBox="0 0 1325 1330.8" style="overflow:visible;enable-background:new 0 0 1325 1330.8;"
    xml:space="preserve">
  <g>
    <rect x="138.4" y="108" class="st0" width="27.2" height="27.2"/>
    <rect x="301.6" y="108" class="st0" width="27.2" height="27.2"/>
    <rect x="138.4" y="135.2" class="st0" width="27.2" height="27.2"/>
    <rect x="165.6" y="135.2" class="st0" width="27.2" height="27.2"/>
    <rect x="274.4" y="135.2" class="st0" width="27.2" height="27.2"/>
    <rect x="301.6" y="135.2" class="st0" width="27.2" height="27.2"/>
    <rect x="138.4" y="162.4" class="st0" width="27.2" height="27.2"/>
    <rect x="165.6" y="162.4" class="st0" width="27.2" height="27.2"/>
    <rect x="192.8" y="162.4" class="st0" width="27.2" height="27.2"/>
    <rect x="247.2" y="162.4" class="st0" width="27.2" height="27.2"/>
    <rect x="274.4" y="162.4" class="st0" width="27.2" height="27.2"/>
    <rect x="301.6" y="162.4" class="st0" width="27.2" height="27.2"/>
    <rect x="56.7" y="189.6" class="st0" width="27.2" height="27.2"/>
    <rect x="83.9" y="189.6" class="st0" width="27.2" height="27.2"/>
    <rect x="111.1" y="189.6" class="st0" width="27.2" height="27.2"/>
    <rect x="165.6" y="189.6" class="st0" width="27.2" height="27.2"/>
    <rect x="192.8" y="189.6" class="st0" width="27.2" height="27.2"/>
    <rect x="247.2" y="189.6" class="st0" width="27.2" height="27.2"/>
    <rect x="274.4" y="189.6" class="st0" width="27.2" height="27.2"/>
    <rect x="328.8" y="189.6" class="st0" width="27.2" height="27.2"/>
    <rect x="356" y="189.6" class="st0" width="27.2" height="27.2"/>
    <rect x="383.2" y="189.6" class="st0" width="27.2" height="27.2"/>
    <rect x="83.9" y="216.8" class="st0" width="27.2" height="27.2"/>
    <rect x="111.1" y="216.8" class="st0" width="27.2" height="27.2"/>
    <rect x="138.4" y="216.8" class="st0" width="27.2" height="27.2"/>
    <rect x="192.8" y="216.8" class="st0" width="27.2" height="27.2"/>
    <rect x="247.2" y="216.8" class="st0" width="27.2" height="27.2"/>
    <rect x="301.6" y="216.8" class="st0" width="27.2" height="27.2"/>
    <rect x="328.8" y="216.8" class="st0" width="27.2" height="27.2"/>
    <rect x="356" y="216.8" class="st0" width="27.2" height="27.2"/>
    <rect x="111.1" y="244" class="st0" width="27.2" height="27.2"/>
    <rect x="138.4" y="244" class="st0" width="27.2" height="27.2"/>
    <rect x="165.6" y="244" class="st0" width="27.2" height="27.2"/>
    <rect x="274.4" y="244" class="st0" width="27.2" height="27.2"/>
    <rect x="301.6" y="244" class="st0" width="27.2" height="27.2"/>
    <rect x="328.8" y="244" class="st0" width="27.2" height="27.2"/>
    <rect x="220" y="271.2" class="st0" width="27.2" height="27.2"/>
    <rect x="111.1" y="298.4" class="st0" width="27.2" height="27.2"/>
    <rect x="138.4" y="298.4" class="st0" width="27.2" height="27.2"/>
    <rect x="165.6" y="298.4" class="st0" width="27.2" height="27.2"/>
    <rect x="274.4" y="298.4" class="st0" width="27.2" height="27.2"/>
    <rect x="301.6" y="298.4" class="st0" width="27.2" height="27.2"/>
    <rect x="328.8" y="298.4" class="st0" width="27.2" height="27.2"/>
    <rect x="83.9" y="325.6" class="st0" width="27.2" height="27.2"/>
    <rect x="111.1" y="325.6" class="st0" width="27.2" height="27.2"/>
    <rect x="138.4" y="325.6" class="st0" width="27.2" height="27.2"/>
    <rect x="192.8" y="325.6" class="st0" width="27.2" height="27.2"/>
    <rect x="247.2" y="325.6" class="st0" width="27.2" height="27.2"/>
    <rect x="301.6" y="325.6" class="st0" width="27.2" height="27.2"/>
    <rect x="328.8" y="325.6" class="st0" width="27.2" height="27.2"/>
    <rect x="356" y="325.6" class="st0" width="27.2" height="27.2"/>
    <rect x="56.7" y="352.8" class="st0" width="27.2" height="27.2"/>
    <rect x="83.9" y="352.8" class="st0" width="27.2" height="27.2"/>
    <rect x="111.1" y="352.8" class="st0" width="27.2" height="27.2"/>
    <rect x="165.6" y="352.8" class="st0" width="27.2" height="27.2"/>
    <rect x="192.8" y="352.8" class="st0" width="27.2" height="27.2"/>
    <rect x="247.2" y="352.8" class="st0" width="27.2" height="27.2"/>
    <rect x="274.4" y="352.8" class="st0" width="27.2" height="27.2"/>
    <rect x="328.8" y="352.8" class="st0" width="27.2" height="27.2"/>
    <rect x="356" y="352.8" class="st0" width="27.2" height="27.2"/>
    <rect x="383.2" y="352.8" class="st0" width="27.2" height="27.2"/>
    <rect x="138.4" y="380" class="st0" width="27.2" height="27.2"/>
    <rect x="165.6" y="380" class="st0" width="27.2" height="27.2"/>
    <rect x="192.8" y="380" class="st0" width="27.2" height="27.2"/>
    <rect x="247.2" y="380" class="st0" width="27.2" height="27.2"/>
    <rect x="274.4" y="380" class="st0" width="27.2" height="27.2"/>
    <rect x="301.6" y="380" class="st0" width="27.2" height="27.2"/>
    <rect x="138.4" y="407.2" class="st0" width="27.2" height="27.2"/>
    <rect x="165.6" y="407.2" class="st0" width="27.2" height="27.2"/>
    <rect x="274.4" y="407.2" class="st0" width="27.2" height="27.2"/>
    <rect x="301.6" y="407.2" class="st0" width="27.2" height="27.2"/>
    <rect x="138.4" y="434.4" class="st0" width="27.2" height="27.2"/>
    <rect x="301.6" y="434.4" class="st0" width="27.2" height="27.2"/>
  </g>
  <g>
    <rect x="1064.3" y="230.2" class="st0" width="17.8" height="17.8"/>
    <rect x="1170.9" y="230.2" class="st0" width="17.8" height="17.8"/>
    <rect x="1064.3" y="248" class="st0" width="17.8" height="17.8"/>
    <rect x="1082.1" y="248" class="st0" width="17.8" height="17.8"/>
    <rect x="1153.2" y="248" class="st0" width="17.8" height="17.8"/>
    <rect x="1170.9" y="248" class="st0" width="17.8" height="17.8"/>
    <rect x="1064.3" y="265.7" class="st0" width="17.8" height="17.8"/>
    <rect x="1082.1" y="265.7" class="st0" width="17.8" height="17.8"/>
    <rect x="1099.9" y="265.7" class="st0" width="17.8" height="17.8"/>
    <rect x="1135.4" y="265.7" class="st0" width="17.8" height="17.8"/>
    <rect x="1153.2" y="265.7" class="st0" width="17.8" height="17.8"/>
    <rect x="1170.9" y="265.7" class="st0" width="17.8" height="17.8"/>
    <rect x="1011" y="283.5" class="st0" width="17.8" height="17.8"/>
    <rect x="1028.8" y="283.5" class="st0" width="17.8" height="17.8"/>
    <rect x="1046.6" y="283.5" class="st0" width="17.8" height="17.8"/>
    <rect x="1082.1" y="283.5" class="st0" width="17.8" height="17.8"/>
    <rect x="1099.9" y="283.5" class="st0" width="17.8" height="17.8"/>
    <rect x="1135.4" y="283.5" class="st0" width="17.8" height="17.8"/>
    <rect x="1153.2" y="283.5" class="st0" width="17.8" height="17.8"/>
    <rect x="1188.7" y="283.5" class="st0" width="17.8" height="17.8"/>
    <rect x="1206.5" y="283.5" class="st0" width="17.8" height="17.8"/>
    <rect x="1224.2" y="283.5" class="st0" width="17.8" height="17.8"/>
    <rect x="1028.8" y="301.3" class="st0" width="17.8" height="17.8"/>
    <rect x="1046.6" y="301.3" class="st0" width="17.8" height="17.8"/>
    <rect x="1064.3" y="301.3" class="st0" width="17.8" height="17.8"/>
    <rect x="1099.9" y="301.3" class="st0" width="17.8" height="17.8"/>
    <rect x="1135.4" y="301.3" class="st0" width="17.8" height="17.8"/>
    <rect x="1170.9" y="301.3" class="st0" width="17.8" height="17.8"/>
    <rect x="1188.7" y="301.3" class="st0" width="17.8" height="17.8"/>
    <rect x="1206.5" y="301.3" class="st0" width="17.8" height="17.8"/>
    <rect x="1046.6" y="319.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1064.3" y="319.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1082.1" y="319.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1153.2" y="319.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1170.9" y="319.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1188.7" y="319.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1117.6" y="336.8" class="st0" width="17.8" height="17.8"/>
    <rect x="1046.6" y="354.6" class="st0" width="17.8" height="17.8"/>
    <rect x="1064.3" y="354.6" class="st0" width="17.8" height="17.8"/>
    <rect x="1082.1" y="354.6" class="st0" width="17.8" height="17.8"/>
    <rect x="1153.2" y="354.6" class="st0" width="17.8" height="17.8"/>
    <rect x="1170.9" y="354.6" class="st0" width="17.8" height="17.8"/>
    <rect x="1188.7" y="354.6" class="st0" width="17.8" height="17.8"/>
    <rect x="1028.8" y="372.4" class="st0" width="17.8" height="17.8"/>
    <rect x="1046.6" y="372.4" class="st0" width="17.8" height="17.8"/>
    <rect x="1064.3" y="372.4" class="st0" width="17.8" height="17.8"/>
    <rect x="1099.9" y="372.4" class="st0" width="17.8" height="17.8"/>
    <rect x="1135.4" y="372.4" class="st0" width="17.8" height="17.8"/>
    <rect x="1170.9" y="372.4" class="st0" width="17.8" height="17.8"/>
    <rect x="1188.7" y="372.4" class="st0" width="17.8" height="17.8"/>
    <rect x="1206.5" y="372.4" class="st0" width="17.8" height="17.8"/>
    <rect x="1011" y="390.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1028.8" y="390.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1046.6" y="390.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1082.1" y="390.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1099.9" y="390.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1135.4" y="390.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1153.2" y="390.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1188.7" y="390.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1206.5" y="390.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1224.2" y="390.1" class="st0" width="17.8" height="17.8"/>
    <rect x="1064.3" y="407.9" class="st0" width="17.8" height="17.8"/>
    <rect x="1082.1" y="407.9" class="st0" width="17.8" height="17.8"/>
    <rect x="1099.9" y="407.9" class="st0" width="17.8" height="17.8"/>
    <rect x="1135.4" y="407.9" class="st0" width="17.8" height="17.8"/>
    <rect x="1153.2" y="407.9" class="st0" width="17.8" height="17.8"/>
    <rect x="1170.9" y="407.9" class="st0" width="17.8" height="17.8"/>
    <rect x="1064.3" y="425.7" class="st0" width="17.8" height="17.8"/>
    <rect x="1082.1" y="425.7" class="st0" width="17.8" height="17.8"/>
    <rect x="1153.2" y="425.7" class="st0" width="17.8" height="17.8"/>
    <rect x="1170.9" y="425.7" class="st0" width="17.8" height="17.8"/>
    <rect x="1064.3" y="443.4" class="st0" width="17.8" height="17.8"/>
    <rect x="1170.9" y="443.4" class="st0" width="17.8" height="17.8"/>
  </g>
  <g>
    <rect x="986.1" y="597.6" class="st0" width="9.6" height="9.6"/>
    <rect x="1043.7" y="597.6" class="st0" width="9.6" height="9.6"/>
    <rect x="986.1" y="607.2" class="st0" width="9.6" height="9.6"/>
    <rect x="995.7" y="607.2" class="st0" width="9.6" height="9.6"/>
    <rect x="1034.1" y="607.2" class="st0" width="9.6" height="9.6"/>
    <rect x="1043.7" y="607.2" class="st0" width="9.6" height="9.6"/>
    <rect x="986.1" y="616.7" class="st0" width="9.6" height="9.6"/>
    <rect x="995.7" y="616.7" class="st0" width="9.6" height="9.6"/>
    <rect x="1005.3" y="616.7" class="st0" width="9.6" height="9.6"/>
    <rect x="1024.5" y="616.7" class="st0" width="9.6" height="9.6"/>
    <rect x="1034.1" y="616.7" class="st0" width="9.6" height="9.6"/>
    <rect x="1043.7" y="616.7" class="st0" width="9.6" height="9.6"/>
    <rect x="957.3" y="626.3" class="st0" width="9.6" height="9.6"/>
    <rect x="966.9" y="626.3" class="st0" width="9.6" height="9.6"/>
    <rect x="976.5" y="626.3" class="st0" width="9.6" height="9.6"/>
    <rect x="995.7" y="626.3" class="st0" width="9.6" height="9.6"/>
    <rect x="1005.3" y="626.3" class="st0" width="9.6" height="9.6"/>
    <rect x="1024.5" y="626.3" class="st0" width="9.6" height="9.6"/>
    <rect x="1034.1" y="626.3" class="st0" width="9.6" height="9.6"/>
    <rect x="1053.2" y="626.3" class="st0" width="9.6" height="9.6"/>
    <rect x="1062.8" y="626.3" class="st0" width="9.6" height="9.6"/>
    <rect x="1072.4" y="626.3" class="st0" width="9.6" height="9.6"/>
    <rect x="966.9" y="635.9" class="st0" width="9.6" height="9.6"/>
    <rect x="976.5" y="635.9" class="st0" width="9.6" height="9.6"/>
    <rect x="986.1" y="635.9" class="st0" width="9.6" height="9.6"/>
    <rect x="1005.3" y="635.9" class="st0" width="9.6" height="9.6"/>
    <rect x="1024.5" y="635.9" class="st0" width="9.6" height="9.6"/>
    <rect x="1043.7" y="635.9" class="st0" width="9.6" height="9.6"/>
    <rect x="1053.2" y="635.9" class="st0" width="9.6" height="9.6"/>
    <rect x="1062.8" y="635.9" class="st0" width="9.6" height="9.6"/>
    <rect x="976.5" y="645.5" class="st0" width="9.6" height="9.6"/>
    <rect x="986.1" y="645.5" class="st0" width="9.6" height="9.6"/>
    <rect x="995.7" y="645.5" class="st0" width="9.6" height="9.6"/>
    <rect x="1034.1" y="645.5" class="st0" width="9.6" height="9.6"/>
    <rect x="1043.7" y="645.5" class="st0" width="9.6" height="9.6"/>
    <rect x="1053.2" y="645.5" class="st0" width="9.6" height="9.6"/>
    <rect x="1014.9" y="655.1" class="st0" width="9.6" height="9.6"/>
    <rect x="976.5" y="664.7" class="st0" width="9.6" height="9.6"/>
    <rect x="986.1" y="664.7" class="st0" width="9.6" height="9.6"/>
    <rect x="995.7" y="664.7" class="st0" width="9.6" height="9.6"/>
    <rect x="1034.1" y="664.7" class="st0" width="9.6" height="9.6"/>
    <rect x="1043.7" y="664.7" class="st0" width="9.6" height="9.6"/>
    <rect x="1053.2" y="664.7" class="st0" width="9.6" height="9.6"/>
    <rect x="966.9" y="674.3" class="st0" width="9.6" height="9.6"/>
    <rect x="976.5" y="674.3" class="st0" width="9.6" height="9.6"/>
    <rect x="986.1" y="674.3" class="st0" width="9.6" height="9.6"/>
    <rect x="1005.3" y="674.3" class="st0" width="9.6" height="9.6"/>
    <rect x="1024.5" y="674.3" class="st0" width="9.6" height="9.6"/>
    <rect x="1043.7" y="674.3" class="st0" width="9.6" height="9.6"/>
    <rect x="1053.2" y="674.3" class="st0" width="9.6" height="9.6"/>
    <rect x="1062.8" y="674.3" class="st0" width="9.6" height="9.6"/>
    <rect x="957.3" y="683.9" class="st0" width="9.6" height="9.6"/>
    <rect x="966.9" y="683.9" class="st0" width="9.6" height="9.6"/>
    <rect x="976.5" y="683.9" class="st0" width="9.6" height="9.6"/>
    <rect x="995.7" y="683.9" class="st0" width="9.6" height="9.6"/>
    <rect x="1005.3" y="683.9" class="st0" width="9.6" height="9.6"/>
    <rect x="1024.5" y="683.9" class="st0" width="9.6" height="9.6"/>
    <rect x="1034.1" y="683.9" class="st0" width="9.6" height="9.6"/>
    <rect x="1053.2" y="683.9" class="st0" width="9.6" height="9.6"/>
    <rect x="1062.8" y="683.9" class="st0" width="9.6" height="9.6"/>
    <rect x="1072.4" y="683.9" class="st0" width="9.6" height="9.6"/>
    <rect x="986.1" y="693.5" class="st0" width="9.6" height="9.6"/>
    <rect x="995.7" y="693.5" class="st0" width="9.6" height="9.6"/>
    <rect x="1005.3" y="693.5" class="st0" width="9.6" height="9.6"/>
    <rect x="1024.5" y="693.5" class="st0" width="9.6" height="9.6"/>
    <rect x="1034.1" y="693.5" class="st0" width="9.6" height="9.6"/>
    <rect x="1043.7" y="693.5" class="st0" width="9.6" height="9.6"/>
    <rect x="986.1" y="703.1" class="st0" width="9.6" height="9.6"/>
    <rect x="995.7" y="703.1" class="st0" width="9.6" height="9.6"/>
    <rect x="1034.1" y="703.1" class="st0" width="9.6" height="9.6"/>
    <rect x="1043.7" y="703.1" class="st0" width="9.6" height="9.6"/>
    <rect x="986.1" y="712.7" class="st0" width="9.6" height="9.6"/>
    <rect x="1043.7" y="712.7" class="st0" width="9.6" height="9.6"/>
  </g>
  <g>
    <rect x="1125.5" y="846.7" class="st0" width="6.7" height="6.7"/>
    <rect x="1165.4" y="846.7" class="st0" width="6.7" height="6.7"/>
    <rect x="1125.5" y="853.3" class="st0" width="6.7" height="6.7"/>
    <rect x="1132.1" y="853.3" class="st0" width="6.7" height="6.7"/>
    <rect x="1158.7" y="853.3" class="st0" width="6.7" height="6.7"/>
    <rect x="1165.4" y="853.3" class="st0" width="6.7" height="6.7"/>
    <rect x="1125.5" y="860" class="st0" width="6.7" height="6.7"/>
    <rect x="1132.1" y="860" class="st0" width="6.7" height="6.7"/>
    <rect x="1138.8" y="860" class="st0" width="6.7" height="6.7"/>
    <rect x="1152.1" y="860" class="st0" width="6.7" height="6.7"/>
    <rect x="1158.7" y="860" class="st0" width="6.7" height="6.7"/>
    <rect x="1165.4" y="860" class="st0" width="6.7" height="6.7"/>
    <rect x="1105.5" y="866.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1112.2" y="866.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1118.8" y="866.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1132.1" y="866.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1138.8" y="866.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1152.1" y="866.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1158.7" y="866.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1172.1" y="866.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1178.7" y="866.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1185.4" y="866.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1112.2" y="873.3" class="st0" width="6.7" height="6.7"/>
    <rect x="1118.8" y="873.3" class="st0" width="6.7" height="6.7"/>
    <rect x="1125.5" y="873.3" class="st0" width="6.7" height="6.7"/>
    <rect x="1138.8" y="873.3" class="st0" width="6.7" height="6.7"/>
    <rect x="1152.1" y="873.3" class="st0" width="6.7" height="6.7"/>
    <rect x="1165.4" y="873.3" class="st0" width="6.7" height="6.7"/>
    <rect x="1172.1" y="873.3" class="st0" width="6.7" height="6.7"/>
    <rect x="1178.7" y="873.3" class="st0" width="6.7" height="6.7"/>
    <rect x="1118.8" y="879.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1125.5" y="879.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1132.1" y="879.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1158.7" y="879.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1165.4" y="879.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1172.1" y="879.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1145.4" y="886.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1118.8" y="893.2" class="st0" width="6.7" height="6.7"/>
    <rect x="1125.5" y="893.2" class="st0" width="6.7" height="6.7"/>
    <rect x="1132.1" y="893.2" class="st0" width="6.7" height="6.7"/>
    <rect x="1158.7" y="893.2" class="st0" width="6.7" height="6.7"/>
    <rect x="1165.4" y="893.2" class="st0" width="6.7" height="6.7"/>
    <rect x="1172.1" y="893.2" class="st0" width="6.7" height="6.7"/>
    <rect x="1112.2" y="899.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1118.8" y="899.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1125.5" y="899.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1138.8" y="899.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1152.1" y="899.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1165.4" y="899.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1172.1" y="899.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1178.7" y="899.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1105.5" y="906.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1112.2" y="906.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1118.8" y="906.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1132.1" y="906.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1138.8" y="906.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1152.1" y="906.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1158.7" y="906.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1172.1" y="906.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1178.7" y="906.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1185.4" y="906.6" class="st0" width="6.7" height="6.7"/>
    <rect x="1125.5" y="913.2" class="st0" width="6.7" height="6.7"/>
    <rect x="1132.1" y="913.2" class="st0" width="6.7" height="6.7"/>
    <rect x="1138.8" y="913.2" class="st0" width="6.7" height="6.7"/>
    <rect x="1152.1" y="913.2" class="st0" width="6.7" height="6.7"/>
    <rect x="1158.7" y="913.2" class="st0" width="6.7" height="6.7"/>
    <rect x="1165.4" y="913.2" class="st0" width="6.7" height="6.7"/>
    <rect x="1125.5" y="919.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1132.1" y="919.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1158.7" y="919.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1165.4" y="919.9" class="st0" width="6.7" height="6.7"/>
    <rect x="1125.5" y="926.5" class="st0" width="6.7" height="6.7"/>
    <rect x="1165.4" y="926.5" class="st0" width="6.7" height="6.7"/>
  </g>
  <g>
    <rect x="1273.9" y="563.9" class="st0" width="5.1" height="5.1"/>
    <rect x="1304.6" y="563.9" class="st0" width="5.1" height="5.1"/>
    <rect x="1273.9" y="569" class="st0" width="5.1" height="5.1"/>
    <rect x="1279" y="569" class="st0" width="5.1" height="5.1"/>
    <rect x="1299.5" y="569" class="st0" width="5.1" height="5.1"/>
    <rect x="1304.6" y="569" class="st0" width="5.1" height="5.1"/>
    <rect x="1273.9" y="574.1" class="st0" width="5.1" height="5.1"/>
    <rect x="1279" y="574.1" class="st0" width="5.1" height="5.1"/>
    <rect x="1284.1" y="574.1" class="st0" width="5.1" height="5.1"/>
    <rect x="1294.4" y="574.1" class="st0" width="5.1" height="5.1"/>
    <rect x="1299.5" y="574.1" class="st0" width="5.1" height="5.1"/>
    <rect x="1304.6" y="574.1" class="st0" width="5.1" height="5.1"/>
    <rect x="1258.6" y="579.2" class="st0" width="5.1" height="5.1"/>
    <rect x="1263.7" y="579.2" class="st0" width="5.1" height="5.1"/>
    <rect x="1268.8" y="579.2" class="st0" width="5.1" height="5.1"/>
    <rect x="1279" y="579.2" class="st0" width="5.1" height="5.1"/>
    <rect x="1284.1" y="579.2" class="st0" width="5.1" height="5.1"/>
    <rect x="1294.4" y="579.2" class="st0" width="5.1" height="5.1"/>
    <rect x="1299.5" y="579.2" class="st0" width="5.1" height="5.1"/>
    <rect x="1309.7" y="579.2" class="st0" width="5.1" height="5.1"/>
    <rect x="1314.8" y="579.2" class="st0" width="5.1" height="5.1"/>
    <rect x="1319.9" y="579.2" class="st0" width="5.1" height="5.1"/>
    <rect x="1263.7" y="584.3" class="st0" width="5.1" height="5.1"/>
    <rect x="1268.8" y="584.3" class="st0" width="5.1" height="5.1"/>
    <rect x="1273.9" y="584.3" class="st0" width="5.1" height="5.1"/>
    <rect x="1284.1" y="584.3" class="st0" width="5.1" height="5.1"/>
    <rect x="1294.4" y="584.3" class="st0" width="5.1" height="5.1"/>
    <rect x="1304.6" y="584.3" class="st0" width="5.1" height="5.1"/>
    <rect x="1309.7" y="584.3" class="st0" width="5.1" height="5.1"/>
    <rect x="1314.8" y="584.3" class="st0" width="5.1" height="5.1"/>
    <rect x="1268.8" y="589.4" class="st0" width="5.1" height="5.1"/>
    <rect x="1273.9" y="589.4" class="st0" width="5.1" height="5.1"/>
    <rect x="1279" y="589.4" class="st0" width="5.1" height="5.1"/>
    <rect x="1299.5" y="589.4" class="st0" width="5.1" height="5.1"/>
    <rect x="1304.6" y="589.4" class="st0" width="5.1" height="5.1"/>
    <rect x="1309.7" y="589.4" class="st0" width="5.1" height="5.1"/>
    <rect x="1289.2" y="594.5" class="st0" width="5.1" height="5.1"/>
    <rect x="1268.8" y="599.7" class="st0" width="5.1" height="5.1"/>
    <rect x="1273.9" y="599.7" class="st0" width="5.1" height="5.1"/>
    <rect x="1279" y="599.7" class="st0" width="5.1" height="5.1"/>
    <rect x="1299.5" y="599.7" class="st0" width="5.1" height="5.1"/>
    <rect x="1304.6" y="599.7" class="st0" width="5.1" height="5.1"/>
    <rect x="1309.7" y="599.7" class="st0" width="5.1" height="5.1"/>
    <rect x="1263.7" y="604.8" class="st0" width="5.1" height="5.1"/>
    <rect x="1268.8" y="604.8" class="st0" width="5.1" height="5.1"/>
    <rect x="1273.9" y="604.8" class="st0" width="5.1" height="5.1"/>
    <rect x="1284.1" y="604.8" class="st0" width="5.1" height="5.1"/>
    <rect x="1294.4" y="604.8" class="st0" width="5.1" height="5.1"/>
    <rect x="1304.6" y="604.8" class="st0" width="5.1" height="5.1"/>
    <rect x="1309.7" y="604.8" class="st0" width="5.1" height="5.1"/>
    <rect x="1314.8" y="604.8" class="st0" width="5.1" height="5.1"/>
    <rect x="1258.6" y="609.9" class="st0" width="5.1" height="5.1"/>
    <rect x="1263.7" y="609.9" class="st0" width="5.1" height="5.1"/>
    <rect x="1268.8" y="609.9" class="st0" width="5.1" height="5.1"/>
    <rect x="1279" y="609.9" class="st0" width="5.1" height="5.1"/>
    <rect x="1284.1" y="609.9" class="st0" width="5.1" height="5.1"/>
    <rect x="1294.4" y="609.9" class="st0" width="5.1" height="5.1"/>
    <rect x="1299.5" y="609.9" class="st0" width="5.1" height="5.1"/>
    <rect x="1309.7" y="609.9" class="st0" width="5.1" height="5.1"/>
    <rect x="1314.8" y="609.9" class="st0" width="5.1" height="5.1"/>
    <rect x="1319.9" y="609.9" class="st0" width="5.1" height="5.1"/>
    <rect x="1273.9" y="615" class="st0" width="5.1" height="5.1"/>
    <rect x="1279" y="615" class="st0" width="5.1" height="5.1"/>
    <rect x="1284.1" y="615" class="st0" width="5.1" height="5.1"/>
    <rect x="1294.4" y="615" class="st0" width="5.1" height="5.1"/>
    <rect x="1299.5" y="615" class="st0" width="5.1" height="5.1"/>
    <rect x="1304.6" y="615" class="st0" width="5.1" height="5.1"/>
    <rect x="1273.9" y="620.1" class="st0" width="5.1" height="5.1"/>
    <rect x="1279" y="620.1" class="st0" width="5.1" height="5.1"/>
    <rect x="1299.5" y="620.1" class="st0" width="5.1" height="5.1"/>
    <rect x="1304.6" y="620.1" class="st0" width="5.1" height="5.1"/>
    <rect x="1273.9" y="625.2" class="st0" width="5.1" height="5.1"/>
    <rect x="1304.6" y="625.2" class="st0" width="5.1" height="5.1"/>
  </g>
  <g>
    <rect x="1121.8" y="1061.7" class="st0" width="14.7" height="14.7"/>
    <rect x="1210.3" y="1061.7" class="st0" width="14.7" height="14.7"/>
    <rect x="1121.8" y="1076.4" class="st0" width="14.7" height="14.7"/>
    <rect x="1136.6" y="1076.4" class="st0" width="14.7" height="14.7"/>
    <rect x="1195.5" y="1076.4" class="st0" width="14.7" height="14.7"/>
    <rect x="1210.3" y="1076.4" class="st0" width="14.7" height="14.7"/>
    <rect x="1121.8" y="1091.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1136.6" y="1091.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1151.3" y="1091.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1180.8" y="1091.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1195.5" y="1091.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1210.3" y="1091.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1077.6" y="1105.9" class="st0" width="14.7" height="14.7"/>
    <rect x="1092.4" y="1105.9" class="st0" width="14.7" height="14.7"/>
    <rect x="1107.1" y="1105.9" class="st0" width="14.7" height="14.7"/>
    <rect x="1136.6" y="1105.9" class="st0" width="14.7" height="14.7"/>
    <rect x="1151.3" y="1105.9" class="st0" width="14.7" height="14.7"/>
    <rect x="1180.8" y="1105.9" class="st0" width="14.7" height="14.7"/>
    <rect x="1195.5" y="1105.9" class="st0" width="14.7" height="14.7"/>
    <rect x="1225" y="1105.9" class="st0" width="14.7" height="14.7"/>
    <rect x="1239.8" y="1105.9" class="st0" width="14.7" height="14.7"/>
    <rect x="1254.5" y="1105.9" class="st0" width="14.7" height="14.7"/>
    <rect x="1092.4" y="1120.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1107.1" y="1120.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1121.8" y="1120.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1151.3" y="1120.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1180.8" y="1120.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1210.3" y="1120.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1225" y="1120.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1239.8" y="1120.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1107.1" y="1135.4" class="st0" width="14.7" height="14.7"/>
    <rect x="1121.8" y="1135.4" class="st0" width="14.7" height="14.7"/>
    <rect x="1136.6" y="1135.4" class="st0" width="14.7" height="14.7"/>
    <rect x="1195.5" y="1135.4" class="st0" width="14.7" height="14.7"/>
    <rect x="1210.3" y="1135.4" class="st0" width="14.7" height="14.7"/>
    <rect x="1225" y="1135.4" class="st0" width="14.7" height="14.7"/>
    <rect x="1166.1" y="1150.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1107.1" y="1164.8" class="st0" width="14.7" height="14.7"/>
    <rect x="1121.8" y="1164.8" class="st0" width="14.7" height="14.7"/>
    <rect x="1136.6" y="1164.8" class="st0" width="14.7" height="14.7"/>
    <rect x="1195.5" y="1164.8" class="st0" width="14.7" height="14.7"/>
    <rect x="1210.3" y="1164.8" class="st0" width="14.7" height="14.7"/>
    <rect x="1225" y="1164.8" class="st0" width="14.7" height="14.7"/>
    <rect x="1092.4" y="1179.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1107.1" y="1179.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1121.8" y="1179.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1151.3" y="1179.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1180.8" y="1179.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1210.3" y="1179.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1225" y="1179.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1239.8" y="1179.6" class="st0" width="14.7" height="14.7"/>
    <rect x="1077.6" y="1194.3" class="st0" width="14.7" height="14.7"/>
    <rect x="1092.4" y="1194.3" class="st0" width="14.7" height="14.7"/>
    <rect x="1107.1" y="1194.3" class="st0" width="14.7" height="14.7"/>
    <rect x="1136.6" y="1194.3" class="st0" width="14.7" height="14.7"/>
    <rect x="1151.3" y="1194.3" class="st0" width="14.7" height="14.7"/>
    <rect x="1180.8" y="1194.3" class="st0" width="14.7" height="14.7"/>
    <rect x="1195.5" y="1194.3" class="st0" width="14.7" height="14.7"/>
    <rect x="1225" y="1194.3" class="st0" width="14.7" height="14.7"/>
    <rect x="1239.8" y="1194.3" class="st0" width="14.7" height="14.7"/>
    <rect x="1254.5" y="1194.3" class="st0" width="14.7" height="14.7"/>
    <rect x="1121.8" y="1209.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1136.6" y="1209.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1151.3" y="1209.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1180.8" y="1209.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1195.5" y="1209.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1210.3" y="1209.1" class="st0" width="14.7" height="14.7"/>
    <rect x="1121.8" y="1223.8" class="st0" width="14.7" height="14.7"/>
    <rect x="1136.6" y="1223.8" class="st0" width="14.7" height="14.7"/>
    <rect x="1195.5" y="1223.8" class="st0" width="14.7" height="14.7"/>
    <rect x="1210.3" y="1223.8" class="st0" width="14.7" height="14.7"/>
    <rect x="1121.8" y="1238.5" class="st0" width="14.7" height="14.7"/>
    <rect x="1210.3" y="1238.5" class="st0" width="14.7" height="14.7"/>
  </g>
  <g>
    <rect x="226" y="866.7" class="st0" width="13" height="13"/>
    <rect x="304" y="866.7" class="st0" width="13" height="13"/>
    <rect x="226" y="879.7" class="st0" width="13" height="13"/>
    <rect x="239" y="879.7" class="st0" width="13" height="13"/>
    <rect x="291" y="879.7" class="st0" width="13" height="13"/>
    <rect x="304" y="879.7" class="st0" width="13" height="13"/>
    <rect x="226" y="892.7" class="st0" width="13" height="13"/>
    <rect x="239" y="892.7" class="st0" width="13" height="13"/>
    <rect x="252" y="892.7" class="st0" width="13" height="13"/>
    <rect x="278" y="892.7" class="st0" width="13" height="13"/>
    <rect x="291" y="892.7" class="st0" width="13" height="13"/>
    <rect x="304" y="892.7" class="st0" width="13" height="13"/>
    <rect x="187" y="905.7" class="st0" width="13" height="13"/>
    <rect x="200" y="905.7" class="st0" width="13" height="13"/>
    <rect x="213" y="905.7" class="st0" width="13" height="13"/>
    <rect x="239" y="905.7" class="st0" width="13" height="13"/>
    <rect x="252" y="905.7" class="st0" width="13" height="13"/>
    <rect x="278" y="905.7" class="st0" width="13" height="13"/>
    <rect x="291" y="905.7" class="st0" width="13" height="13"/>
    <rect x="317" y="905.7" class="st0" width="13" height="13"/>
    <rect x="330" y="905.7" class="st0" width="13" height="13"/>
    <rect x="343" y="905.7" class="st0" width="13" height="13"/>
    <rect x="200" y="918.7" class="st0" width="13" height="13"/>
    <rect x="213" y="918.7" class="st0" width="13" height="13"/>
    <rect x="226" y="918.7" class="st0" width="13" height="13"/>
    <rect x="252" y="918.7" class="st0" width="13" height="13"/>
    <rect x="278" y="918.7" class="st0" width="13" height="13"/>
    <rect x="304" y="918.7" class="st0" width="13" height="13"/>
    <rect x="317" y="918.7" class="st0" width="13" height="13"/>
    <rect x="330" y="918.7" class="st0" width="13" height="13"/>
    <rect x="213" y="931.6" class="st0" width="13" height="13"/>
    <rect x="226" y="931.6" class="st0" width="13" height="13"/>
    <rect x="239" y="931.6" class="st0" width="13" height="13"/>
    <rect x="291" y="931.6" class="st0" width="13" height="13"/>
    <rect x="304" y="931.6" class="st0" width="13" height="13"/>
    <rect x="317" y="931.6" class="st0" width="13" height="13"/>
    <rect x="265" y="944.6" class="st0" width="13" height="13"/>
    <rect x="213" y="957.6" class="st0" width="13" height="13"/>
    <rect x="226" y="957.6" class="st0" width="13" height="13"/>
    <rect x="239" y="957.6" class="st0" width="13" height="13"/>
    <rect x="291" y="957.6" class="st0" width="13" height="13"/>
    <rect x="304" y="957.6" class="st0" width="13" height="13"/>
    <rect x="317" y="957.6" class="st0" width="13" height="13"/>
    <rect x="200" y="970.6" class="st0" width="13" height="13"/>
    <rect x="213" y="970.6" class="st0" width="13" height="13"/>
    <rect x="226" y="970.6" class="st0" width="13" height="13"/>
    <rect x="252" y="970.6" class="st0" width="13" height="13"/>
    <rect x="278" y="970.6" class="st0" width="13" height="13"/>
    <rect x="304" y="970.6" class="st0" width="13" height="13"/>
    <rect x="317" y="970.6" class="st0" width="13" height="13"/>
    <rect x="330" y="970.6" class="st0" width="13" height="13"/>
    <rect x="187" y="983.6" class="st0" width="13" height="13"/>
    <rect x="200" y="983.6" class="st0" width="13" height="13"/>
    <rect x="213" y="983.6" class="st0" width="13" height="13"/>
    <rect x="239" y="983.6" class="st0" width="13" height="13"/>
    <rect x="252" y="983.6" class="st0" width="13" height="13"/>
    <rect x="278" y="983.6" class="st0" width="13" height="13"/>
    <rect x="291" y="983.6" class="st0" width="13" height="13"/>
    <rect x="317" y="983.6" class="st0" width="13" height="13"/>
    <rect x="330" y="983.6" class="st0" width="13" height="13"/>
    <rect x="343" y="983.6" class="st0" width="13" height="13"/>
    <rect x="226" y="996.6" class="st0" width="13" height="13"/>
    <rect x="239" y="996.6" class="st0" width="13" height="13"/>
    <rect x="252" y="996.6" class="st0" width="13" height="13"/>
    <rect x="278" y="996.6" class="st0" width="13" height="13"/>
    <rect x="291" y="996.6" class="st0" width="13" height="13"/>
    <rect x="304" y="996.6" class="st0" width="13" height="13"/>
    <rect x="226" y="1009.6" class="st0" width="13" height="13"/>
    <rect x="239" y="1009.6" class="st0" width="13" height="13"/>
    <rect x="291" y="1009.6" class="st0" width="13" height="13"/>
    <rect x="304" y="1009.6" class="st0" width="13" height="13"/>
    <rect x="226" y="1022.6" class="st0" width="13" height="13"/>
    <rect x="304" y="1022.6" class="st0" width="13" height="13"/>
  </g>
  <g>
    <rect x="292" y="532.9" class="st0" width="6.9" height="6.9"/>
    <rect x="333.4" y="532.9" class="st0" width="6.9" height="6.9"/>
    <rect x="292" y="539.8" class="st0" width="6.9" height="6.9"/>
    <rect x="298.9" y="539.8" class="st0" width="6.9" height="6.9"/>
    <rect x="326.5" y="539.8" class="st0" width="6.9" height="6.9"/>
    <rect x="333.4" y="539.8" class="st0" width="6.9" height="6.9"/>
    <rect x="292" y="546.7" class="st0" width="6.9" height="6.9"/>
    <rect x="298.9" y="546.7" class="st0" width="6.9" height="6.9"/>
    <rect x="305.8" y="546.7" class="st0" width="6.9" height="6.9"/>
    <rect x="319.6" y="546.7" class="st0" width="6.9" height="6.9"/>
    <rect x="326.5" y="546.7" class="st0" width="6.9" height="6.9"/>
    <rect x="333.4" y="546.7" class="st0" width="6.9" height="6.9"/>
    <rect x="271.3" y="553.6" class="st0" width="6.9" height="6.9"/>
    <rect x="278.2" y="553.6" class="st0" width="6.9" height="6.9"/>
    <rect x="285.1" y="553.6" class="st0" width="6.9" height="6.9"/>
    <rect x="298.9" y="553.6" class="st0" width="6.9" height="6.9"/>
    <rect x="305.8" y="553.6" class="st0" width="6.9" height="6.9"/>
    <rect x="319.6" y="553.6" class="st0" width="6.9" height="6.9"/>
    <rect x="326.5" y="553.6" class="st0" width="6.9" height="6.9"/>
    <rect x="340.3" y="553.6" class="st0" width="6.9" height="6.9"/>
    <rect x="347.2" y="553.6" class="st0" width="6.9" height="6.9"/>
    <rect x="354.1" y="553.6" class="st0" width="6.9" height="6.9"/>
    <rect x="278.2" y="560.5" class="st0" width="6.9" height="6.9"/>
    <rect x="285.1" y="560.5" class="st0" width="6.9" height="6.9"/>
    <rect x="292" y="560.5" class="st0" width="6.9" height="6.9"/>
    <rect x="305.8" y="560.5" class="st0" width="6.9" height="6.9"/>
    <rect x="319.6" y="560.5" class="st0" width="6.9" height="6.9"/>
    <rect x="333.4" y="560.5" class="st0" width="6.9" height="6.9"/>
    <rect x="340.3" y="560.5" class="st0" width="6.9" height="6.9"/>
    <rect x="347.2" y="560.5" class="st0" width="6.9" height="6.9"/>
    <rect x="285.1" y="567.4" class="st0" width="6.9" height="6.9"/>
    <rect x="292" y="567.4" class="st0" width="6.9" height="6.9"/>
    <rect x="298.9" y="567.4" class="st0" width="6.9" height="6.9"/>
    <rect x="326.5" y="567.4" class="st0" width="6.9" height="6.9"/>
    <rect x="333.4" y="567.4" class="st0" width="6.9" height="6.9"/>
    <rect x="340.3" y="567.4" class="st0" width="6.9" height="6.9"/>
    <rect x="312.7" y="574.3" class="st0" width="6.9" height="6.9"/>
    <rect x="285.1" y="581.2" class="st0" width="6.9" height="6.9"/>
    <rect x="292" y="581.2" class="st0" width="6.9" height="6.9"/>
    <rect x="298.9" y="581.2" class="st0" width="6.9" height="6.9"/>
    <rect x="326.5" y="581.2" class="st0" width="6.9" height="6.9"/>
    <rect x="333.4" y="581.2" class="st0" width="6.9" height="6.9"/>
    <rect x="340.3" y="581.2" class="st0" width="6.9" height="6.9"/>
    <rect x="278.2" y="588.1" class="st0" width="6.9" height="6.9"/>
    <rect x="285.1" y="588.1" class="st0" width="6.9" height="6.9"/>
    <rect x="292" y="588.1" class="st0" width="6.9" height="6.9"/>
    <rect x="305.8" y="588.1" class="st0" width="6.9" height="6.9"/>
    <rect x="319.6" y="588.1" class="st0" width="6.9" height="6.9"/>
    <rect x="333.4" y="588.1" class="st0" width="6.9" height="6.9"/>
    <rect x="340.3" y="588.1" class="st0" width="6.9" height="6.9"/>
    <rect x="347.2" y="588.1" class="st0" width="6.9" height="6.9"/>
    <rect x="271.3" y="595" class="st0" width="6.9" height="6.9"/>
    <rect x="278.2" y="595" class="st0" width="6.9" height="6.9"/>
    <rect x="285.1" y="595" class="st0" width="6.9" height="6.9"/>
    <rect x="298.9" y="595" class="st0" width="6.9" height="6.9"/>
    <rect x="305.8" y="595" class="st0" width="6.9" height="6.9"/>
    <rect x="319.6" y="595" class="st0" width="6.9" height="6.9"/>
    <rect x="326.5" y="595" class="st0" width="6.9" height="6.9"/>
    <rect x="340.3" y="595" class="st0" width="6.9" height="6.9"/>
    <rect x="347.2" y="595" class="st0" width="6.9" height="6.9"/>
    <rect x="354.1" y="595" class="st0" width="6.9" height="6.9"/>
    <rect x="292" y="601.9" class="st0" width="6.9" height="6.9"/>
    <rect x="298.9" y="601.9" class="st0" width="6.9" height="6.9"/>
    <rect x="305.8" y="601.9" class="st0" width="6.9" height="6.9"/>
    <rect x="319.6" y="601.9" class="st0" width="6.9" height="6.9"/>
    <rect x="326.5" y="601.9" class="st0" width="6.9" height="6.9"/>
    <rect x="333.4" y="601.9" class="st0" width="6.9" height="6.9"/>
    <rect x="292" y="608.8" class="st0" width="6.9" height="6.9"/>
    <rect x="298.9" y="608.8" class="st0" width="6.9" height="6.9"/>
    <rect x="326.5" y="608.8" class="st0" width="6.9" height="6.9"/>
    <rect x="333.4" y="608.8" class="st0" width="6.9" height="6.9"/>
    <rect x="292" y="615.7" class="st0" width="6.9" height="6.9"/>
    <rect x="333.4" y="615.7" class="st0" width="6.9" height="6.9"/>
  </g>
  <g>
    <rect x="29.9" y="663.2" class="st0" width="10" height="10"/>
    <rect x="89.6" y="663.2" class="st0" width="10" height="10"/>
    <rect x="29.9" y="673.2" class="st0" width="10" height="10"/>
    <rect x="39.8" y="673.2" class="st0" width="10" height="10"/>
    <rect x="79.6" y="673.2" class="st0" width="10" height="10"/>
    <rect x="89.6" y="673.2" class="st0" width="10" height="10"/>
    <rect x="29.9" y="683.1" class="st0" width="10" height="10"/>
    <rect x="39.8" y="683.1" class="st0" width="10" height="10"/>
    <rect x="49.8" y="683.1" class="st0" width="10" height="10"/>
    <rect x="69.7" y="683.1" class="st0" width="10" height="10"/>
    <rect x="79.6" y="683.1" class="st0" width="10" height="10"/>
    <rect x="89.6" y="683.1" class="st0" width="10" height="10"/>
    <rect y="693.1" class="st0" width="10" height="10"/>
    <rect x="10" y="693.1" class="st0" width="10" height="10"/>
    <rect x="19.9" y="693.1" class="st0" width="10" height="10"/>
    <rect x="39.8" y="693.1" class="st0" width="10" height="10"/>
    <rect x="49.8" y="693.1" class="st0" width="10" height="10"/>
    <rect x="69.7" y="693.1" class="st0" width="10" height="10"/>
    <rect x="79.6" y="693.1" class="st0" width="10" height="10"/>
    <rect x="99.6" y="693.1" class="st0" width="10" height="10"/>
    <rect x="109.5" y="693.1" class="st0" width="10" height="10"/>
    <rect x="119.5" y="693.1" class="st0" width="10" height="10"/>
    <rect x="10" y="703" class="st0" width="10" height="10"/>
    <rect x="19.9" y="703" class="st0" width="10" height="10"/>
    <rect x="29.9" y="703" class="st0" width="10" height="10"/>
    <rect x="49.8" y="703" class="st0" width="10" height="10"/>
    <rect x="69.7" y="703" class="st0" width="10" height="10"/>
    <rect x="89.6" y="703" class="st0" width="10" height="10"/>
    <rect x="99.6" y="703" class="st0" width="10" height="10"/>
    <rect x="109.5" y="703" class="st0" width="10" height="10"/>
    <rect x="19.9" y="713" class="st0" width="10" height="10"/>
    <rect x="29.9" y="713" class="st0" width="10" height="10"/>
    <rect x="39.8" y="713" class="st0" width="10" height="10"/>
    <rect x="79.6" y="713" class="st0" width="10" height="10"/>
    <rect x="89.6" y="713" class="st0" width="10" height="10"/>
    <rect x="99.6" y="713" class="st0" width="10" height="10"/>
    <rect x="59.7" y="723" class="st0" width="10" height="10"/>
    <rect x="19.9" y="732.9" class="st0" width="10" height="10"/>
    <rect x="29.9" y="732.9" class="st0" width="10" height="10"/>
    <rect x="39.8" y="732.9" class="st0" width="10" height="10"/>
    <rect x="79.6" y="732.9" class="st0" width="10" height="10"/>
    <rect x="89.6" y="732.9" class="st0" width="10" height="10"/>
    <rect x="99.6" y="732.9" class="st0" width="10" height="10"/>
    <rect x="10" y="742.9" class="st0" width="10" height="10"/>
    <rect x="19.9" y="742.9" class="st0" width="10" height="10"/>
    <rect x="29.9" y="742.9" class="st0" width="10" height="10"/>
    <rect x="49.8" y="742.9" class="st0" width="10" height="10"/>
    <rect x="69.7" y="742.9" class="st0" width="10" height="10"/>
    <rect x="89.6" y="742.9" class="st0" width="10" height="10"/>
    <rect x="99.6" y="742.9" class="st0" width="10" height="10"/>
    <rect x="109.5" y="742.9" class="st0" width="10" height="10"/>
    <rect y="752.8" class="st0" width="10" height="10"/>
    <rect x="10" y="752.8" class="st0" width="10" height="10"/>
    <rect x="19.9" y="752.8" class="st0" width="10" height="10"/>
    <rect x="39.8" y="752.8" class="st0" width="10" height="10"/>
    <rect x="49.8" y="752.8" class="st0" width="10" height="10"/>
    <rect x="69.7" y="752.8" class="st0" width="10" height="10"/>
    <rect x="79.6" y="752.8" class="st0" width="10" height="10"/>
    <rect x="99.6" y="752.8" class="st0" width="10" height="10"/>
    <rect x="109.5" y="752.8" class="st0" width="10" height="10"/>
    <rect x="119.5" y="752.8" class="st0" width="10" height="10"/>
    <rect x="29.9" y="762.8" class="st0" width="10" height="10"/>
    <rect x="39.8" y="762.8" class="st0" width="10" height="10"/>
    <rect x="49.8" y="762.8" class="st0" width="10" height="10"/>
    <rect x="69.7" y="762.8" class="st0" width="10" height="10"/>
    <rect x="79.6" y="762.8" class="st0" width="10" height="10"/>
    <rect x="89.6" y="762.8" class="st0" width="10" height="10"/>
    <rect x="29.9" y="772.7" class="st0" width="10" height="10"/>
    <rect x="39.8" y="772.7" class="st0" width="10" height="10"/>
    <rect x="79.6" y="772.7" class="st0" width="10" height="10"/>
    <rect x="89.6" y="772.7" class="st0" width="10" height="10"/>
    <rect x="29.9" y="782.7" class="st0" width="10" height="10"/>
    <rect x="89.6" y="782.7" class="st0" width="10" height="10"/>
  </g>
  <g>
    <rect x="52.3" y="1156.7" class="st0" width="13.4" height="13.4"/>
    <rect x="132.7" y="1156.7" class="st0" width="13.4" height="13.4"/>
    <rect x="52.3" y="1170" class="st0" width="13.4" height="13.4"/>
    <rect x="65.7" y="1170" class="st0" width="13.4" height="13.4"/>
    <rect x="119.3" y="1170" class="st0" width="13.4" height="13.4"/>
    <rect x="132.7" y="1170" class="st0" width="13.4" height="13.4"/>
    <rect x="52.3" y="1183.4" class="st0" width="13.4" height="13.4"/>
    <rect x="65.7" y="1183.4" class="st0" width="13.4" height="13.4"/>
    <rect x="79.1" y="1183.4" class="st0" width="13.4" height="13.4"/>
    <rect x="105.9" y="1183.4" class="st0" width="13.4" height="13.4"/>
    <rect x="119.3" y="1183.4" class="st0" width="13.4" height="13.4"/>
    <rect x="132.7" y="1183.4" class="st0" width="13.4" height="13.4"/>
    <rect x="12.1" y="1196.8" class="st0" width="13.4" height="13.4"/>
    <rect x="25.5" y="1196.8" class="st0" width="13.4" height="13.4"/>
    <rect x="38.9" y="1196.8" class="st0" width="13.4" height="13.4"/>
    <rect x="65.7" y="1196.8" class="st0" width="13.4" height="13.4"/>
    <rect x="79.1" y="1196.8" class="st0" width="13.4" height="13.4"/>
    <rect x="105.9" y="1196.8" class="st0" width="13.4" height="13.4"/>
    <rect x="119.3" y="1196.8" class="st0" width="13.4" height="13.4"/>
    <rect x="146.1" y="1196.8" class="st0" width="13.4" height="13.4"/>
    <rect x="159.5" y="1196.8" class="st0" width="13.4" height="13.4"/>
    <rect x="172.9" y="1196.8" class="st0" width="13.4" height="13.4"/>
    <rect x="25.5" y="1210.2" class="st0" width="13.4" height="13.4"/>
    <rect x="38.9" y="1210.2" class="st0" width="13.4" height="13.4"/>
    <rect x="52.3" y="1210.2" class="st0" width="13.4" height="13.4"/>
    <rect x="79.1" y="1210.2" class="st0" width="13.4" height="13.4"/>
    <rect x="105.9" y="1210.2" class="st0" width="13.4" height="13.4"/>
    <rect x="132.7" y="1210.2" class="st0" width="13.4" height="13.4"/>
    <rect x="146.1" y="1210.2" class="st0" width="13.4" height="13.4"/>
    <rect x="159.5" y="1210.2" class="st0" width="13.4" height="13.4"/>
    <rect x="38.9" y="1223.6" class="st0" width="13.4" height="13.4"/>
    <rect x="52.3" y="1223.6" class="st0" width="13.4" height="13.4"/>
    <rect x="65.7" y="1223.6" class="st0" width="13.4" height="13.4"/>
    <rect x="119.3" y="1223.6" class="st0" width="13.4" height="13.4"/>
    <rect x="132.7" y="1223.6" class="st0" width="13.4" height="13.4"/>
    <rect x="146.1" y="1223.6" class="st0" width="13.4" height="13.4"/>
    <rect x="92.5" y="1237" class="st0" width="13.4" height="13.4"/>
    <rect x="38.9" y="1250.4" class="st0" width="13.4" height="13.4"/>
    <rect x="52.3" y="1250.4" class="st0" width="13.4" height="13.4"/>
    <rect x="65.7" y="1250.4" class="st0" width="13.4" height="13.4"/>
    <rect x="119.3" y="1250.4" class="st0" width="13.4" height="13.4"/>
    <rect x="132.7" y="1250.4" class="st0" width="13.4" height="13.4"/>
    <rect x="146.1" y="1250.4" class="st0" width="13.4" height="13.4"/>
    <rect x="25.5" y="1263.8" class="st0" width="13.4" height="13.4"/>
    <rect x="38.9" y="1263.8" class="st0" width="13.4" height="13.4"/>
    <rect x="52.3" y="1263.8" class="st0" width="13.4" height="13.4"/>
    <rect x="79.1" y="1263.8" class="st0" width="13.4" height="13.4"/>
    <rect x="105.9" y="1263.8" class="st0" width="13.4" height="13.4"/>
    <rect x="132.7" y="1263.8" class="st0" width="13.4" height="13.4"/>
    <rect x="146.1" y="1263.8" class="st0" width="13.4" height="13.4"/>
    <rect x="159.5" y="1263.8" class="st0" width="13.4" height="13.4"/>
    <rect x="12.1" y="1277.2" class="st0" width="13.4" height="13.4"/>
    <rect x="25.5" y="1277.2" class="st0" width="13.4" height="13.4"/>
    <rect x="38.9" y="1277.2" class="st0" width="13.4" height="13.4"/>
    <rect x="65.7" y="1277.2" class="st0" width="13.4" height="13.4"/>
    <rect x="79.1" y="1277.2" class="st0" width="13.4" height="13.4"/>
    <rect x="105.9" y="1277.2" class="st0" width="13.4" height="13.4"/>
    <rect x="119.3" y="1277.2" class="st0" width="13.4" height="13.4"/>
    <rect x="146.1" y="1277.2" class="st0" width="13.4" height="13.4"/>
    <rect x="159.5" y="1277.2" class="st0" width="13.4" height="13.4"/>
    <rect x="172.9" y="1277.2" class="st0" width="13.4" height="13.4"/>
    <rect x="52.3" y="1290.6" class="st0" width="13.4" height="13.4"/>
    <rect x="65.7" y="1290.6" class="st0" width="13.4" height="13.4"/>
    <rect x="79.1" y="1290.6" class="st0" width="13.4" height="13.4"/>
    <rect x="105.9" y="1290.6" class="st0" width="13.4" height="13.4"/>
    <rect x="119.3" y="1290.6" class="st0" width="13.4" height="13.4"/>
    <rect x="132.7" y="1290.6" class="st0" width="13.4" height="13.4"/>
    <rect x="52.3" y="1304" class="st0" width="13.4" height="13.4"/>
    <rect x="65.7" y="1304" class="st0" width="13.4" height="13.4"/>
    <rect x="119.3" y="1304" class="st0" width="13.4" height="13.4"/>
    <rect x="132.7" y="1304" class="st0" width="13.4" height="13.4"/>
    <rect x="52.3" y="1317.4" class="st0" width="13.4" height="13.4"/>
    <rect x="132.7" y="1317.4" class="st0" width="13.4" height="13.4"/>
  </g>
  <g>
    <rect x="584.5" class="st0" width="9.2" height="9.2"/>
    <rect x="640" class="st0" width="9.2" height="9.2"/>
    <rect x="584.5" y="9.2" class="st0" width="9.2" height="9.2"/>
    <rect x="593.8" y="9.2" class="st0" width="9.2" height="9.2"/>
    <rect x="630.8" y="9.2" class="st0" width="9.2" height="9.2"/>
    <rect x="640" y="9.2" class="st0" width="9.2" height="9.2"/>
    <rect x="584.5" y="18.5" class="st0" width="9.2" height="9.2"/>
    <rect x="593.8" y="18.5" class="st0" width="9.2" height="9.2"/>
    <rect x="603" y="18.5" class="st0" width="9.2" height="9.2"/>
    <rect x="621.5" y="18.5" class="st0" width="9.2" height="9.2"/>
    <rect x="630.8" y="18.5" class="st0" width="9.2" height="9.2"/>
    <rect x="640" y="18.5" class="st0" width="9.2" height="9.2"/>
    <rect x="556.8" y="27.7" class="st0" width="9.2" height="9.2"/>
    <rect x="566" y="27.7" class="st0" width="9.2" height="9.2"/>
    <rect x="575.3" y="27.7" class="st0" width="9.2" height="9.2"/>
    <rect x="593.8" y="27.7" class="st0" width="9.2" height="9.2"/>
    <rect x="603" y="27.7" class="st0" width="9.2" height="9.2"/>
    <rect x="621.5" y="27.7" class="st0" width="9.2" height="9.2"/>
    <rect x="630.8" y="27.7" class="st0" width="9.2" height="9.2"/>
    <rect x="649.3" y="27.7" class="st0" width="9.2" height="9.2"/>
    <rect x="658.5" y="27.7" class="st0" width="9.2" height="9.2"/>
    <rect x="667.8" y="27.7" class="st0" width="9.2" height="9.2"/>
    <rect x="566" y="37" class="st0" width="9.2" height="9.2"/>
    <rect x="575.3" y="37" class="st0" width="9.2" height="9.2"/>
    <rect x="584.5" y="37" class="st0" width="9.2" height="9.2"/>
    <rect x="603" y="37" class="st0" width="9.2" height="9.2"/>
    <rect x="621.5" y="37" class="st0" width="9.2" height="9.2"/>
    <rect x="640" y="37" class="st0" width="9.2" height="9.2"/>
    <rect x="649.3" y="37" class="st0" width="9.2" height="9.2"/>
    <rect x="658.5" y="37" class="st0" width="9.2" height="9.2"/>
    <rect x="575.3" y="46.2" class="st0" width="9.2" height="9.2"/>
    <rect x="584.5" y="46.2" class="st0" width="9.2" height="9.2"/>
    <rect x="593.8" y="46.2" class="st0" width="9.2" height="9.2"/>
    <rect x="630.8" y="46.2" class="st0" width="9.2" height="9.2"/>
    <rect x="640" y="46.2" class="st0" width="9.2" height="9.2"/>
    <rect x="649.3" y="46.2" class="st0" width="9.2" height="9.2"/>
    <rect x="612.3" y="55.5" class="st0" width="9.2" height="9.2"/>
    <rect x="575.3" y="64.7" class="st0" width="9.2" height="9.2"/>
    <rect x="584.5" y="64.7" class="st0" width="9.2" height="9.2"/>
    <rect x="593.8" y="64.7" class="st0" width="9.2" height="9.2"/>
    <rect x="630.8" y="64.7" class="st0" width="9.2" height="9.2"/>
    <rect x="640" y="64.7" class="st0" width="9.2" height="9.2"/>
    <rect x="649.3" y="64.7" class="st0" width="9.2" height="9.2"/>
    <rect x="566" y="74" class="st0" width="9.2" height="9.2"/>
    <rect x="575.3" y="74" class="st0" width="9.2" height="9.2"/>
    <rect x="584.5" y="74" class="st0" width="9.2" height="9.2"/>
    <rect x="603" y="74" class="st0" width="9.2" height="9.2"/>
    <rect x="621.5" y="74" class="st0" width="9.2" height="9.2"/>
    <rect x="640" y="74" class="st0" width="9.2" height="9.2"/>
    <rect x="649.3" y="74" class="st0" width="9.2" height="9.2"/>
    <rect x="658.5" y="74" class="st0" width="9.2" height="9.2"/>
    <rect x="556.8" y="83.2" class="st0" width="9.2" height="9.2"/>
    <rect x="566" y="83.2" class="st0" width="9.2" height="9.2"/>
    <rect x="575.3" y="83.2" class="st0" width="9.2" height="9.2"/>
    <rect x="593.8" y="83.2" class="st0" width="9.2" height="9.2"/>
    <rect x="603" y="83.2" class="st0" width="9.2" height="9.2"/>
    <rect x="621.5" y="83.2" class="st0" width="9.2" height="9.2"/>
    <rect x="630.8" y="83.2" class="st0" width="9.2" height="9.2"/>
    <rect x="649.3" y="83.2" class="st0" width="9.2" height="9.2"/>
    <rect x="658.5" y="83.2" class="st0" width="9.2" height="9.2"/>
    <rect x="667.8" y="83.2" class="st0" width="9.2" height="9.2"/>
    <rect x="584.5" y="92.5" class="st0" width="9.2" height="9.2"/>
    <rect x="593.8" y="92.5" class="st0" width="9.2" height="9.2"/>
    <rect x="603" y="92.5" class="st0" width="9.2" height="9.2"/>
    <rect x="621.5" y="92.5" class="st0" width="9.2" height="9.2"/>
    <rect x="630.8" y="92.5" class="st0" width="9.2" height="9.2"/>
    <rect x="640" y="92.5" class="st0" width="9.2" height="9.2"/>
    <rect x="584.5" y="101.7" class="st0" width="9.2" height="9.2"/>
    <rect x="593.8" y="101.7" class="st0" width="9.2" height="9.2"/>
    <rect x="630.8" y="101.7" class="st0" width="9.2" height="9.2"/>
    <rect x="640" y="101.7" class="st0" width="9.2" height="9.2"/>
    <rect x="584.5" y="111" class="st0" width="9.2" height="9.2"/>
    <rect x="640" y="111" class="st0" width="9.2" height="9.2"/>
  </g>
</svg>
</template>

<script>
export default {

}
</script>

<style type="text/css">
  .st0 { fill: currentColor; }
</style>
